import React from "react";
import styled from "styled-components";
import { Colors } from "../../config";
import LabelAndAmount from "./LabelAndAmount";

const TotalWrapper = ({ total }) => {
  return (
    <FlexEnd>
      <LabelAndAmount
        amount={total}
        amountFontSize="2rem"
        grayQar
        amountFontColor={Colors.brandOne}
      />
    </FlexEnd>
  );
};

export default TotalWrapper;

const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  background-color: ${Colors.bombay};
  border-radius: 0 0 0.5rem 0.5rem;
  padding: 0.688rem 1.375rem 0.688rem 0rem;
`;
